import { Behaviors } from '../types';

export const DefaultBehaviors: Behaviors = {
  selectable: true,
  removable: true,
};
